import React from 'react';
import Icon from '../../../../components/AppIcon';
import Button from '../../../../components/ui/Button';
import { SCENARIO_COLORS } from './analysisMetrics';
import { getScenarioLabel } from './analysisCompareUtils';

const AnalysisToolbar = ({
  scenarioAId,
  scenarioBId,
  onScenarioAChange,
  onScenarioBChange,
  scenarios,
  activeScenarioId,
  yearIndex,
  onYearIndexChange,
  projectionRows,
  planningHorizonYears,
  planningDeathYear,
  onGoToPlanning,
  compareEnabled,
}) => {
  const maxIndex = Math.max(0, (projectionRows?.length || 1) - 1);
  const currentRow = projectionRows?.[yearIndex];
  const labelA = getScenarioLabel(scenarioAId, scenarios, activeScenarioId);
  const labelB = getScenarioLabel(scenarioBId, scenarios, activeScenarioId);

  return (
    <div className="rounded-xl border border-border bg-card p-4 space-y-4" data-testid="analysis-toolbar">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        <div className="flex-1 space-y-3">
          <p className="text-sm font-semibold text-foreground">Comparaison de scénarios</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-muted-foreground mb-1 flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full" style={{ background: SCENARIO_COLORS.A }} />
                Scénario A
              </label>
              <select
                value={scenarioAId}
                onChange={(e) => onScenarioAChange(e.target.value)}
                className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
              >
                <option value="__current__">Données courantes</option>
                {scenarios.map((s) => (
                  <option key={`a-${s.id}`} value={s.id}>{s.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-xs text-muted-foreground mb-1 flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full" style={{ background: SCENARIO_COLORS.B }} />
                Scénario B
              </label>
              <select
                value={scenarioBId}
                onChange={(e) => onScenarioBChange(e.target.value)}
                className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
              >
                <option value="__current__">Données courantes</option>
                {scenarios.map((s) => (
                  <option key={`b-${s.id}`} value={s.id}>{s.name}</option>
                ))}
              </select>
            </div>
          </div>
          {compareEnabled && (
            <p className="text-xs text-muted-foreground">
              <span style={{ color: SCENARIO_COLORS.A }} className="font-medium">{labelA}</span>
              {' vs '}
              <span style={{ color: SCENARIO_COLORS.B }} className="font-medium">{labelB}</span>
            </p>
          )}
        </div>

        <div className="flex flex-col sm:flex-row gap-3 sm:items-end">
          <div className="text-xs text-muted-foreground">
            <p>Horizon : <span className="font-medium text-foreground">{planningHorizonYears} ans</span></p>
            <p>Décès simulé : <span className="font-medium text-foreground">{planningDeathYear}</span></p>
          </div>
          {onGoToPlanning && (
            <Button size="sm" variant="outline" iconName="Settings" onClick={onGoToPlanning}>
              Modifier dans Planification
            </Button>
          )}
        </div>
      </div>

      {projectionRows?.length > 0 && (
        <div data-testid="analysis-year-slider" className="rounded-lg border border-border bg-muted/20 p-3">
          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            <div className="flex items-center gap-2 shrink-0">
              <Icon name="CalendarDays" size={16} className="text-primary" />
              <span className="text-sm font-medium text-foreground">Année d&apos;analyse</span>
            </div>
            <input
              type="range"
              min={0}
              max={maxIndex}
              value={yearIndex}
              onChange={(e) => onYearIndexChange(parseInt(e.target.value, 10))}
              className="flex-1 accent-primary"
            />
            <span className="text-lg font-bold text-primary tabular-nums shrink-0" style={{ fontFamily: 'var(--font-data)' }}>
              {currentRow?.year ?? '—'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnalysisToolbar;



